export default __webpack_public_path__ + "c2aa4c6733fccd65c46606b2dfa68f2e.png";